import { Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivate,
  Router,
  RouterStateSnapshot,
  UrlTree,
} from '@angular/router';
import { Observable } from 'rxjs';
import { AuthService } from '../services/auth.service';

/**
 * Guard to protect routes that should only be accessible BEFORE login.
 * If the user is already logged in, they will be redirected to the landing page.
 * If the user is not logged in, they can access the route (login, forgot password, etc).
 */
@Injectable({
  providedIn: 'root',
})
export class BeforeLoginGuard implements CanActivate {
  constructor(
    private authService: AuthService,
    private router: Router,
  ) {}

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
  ):
    | Observable<boolean | UrlTree>
    | Promise<boolean | UrlTree>
    | boolean
    | UrlTree {
    const isAlreadyLoggedIn = this.authService.alreadyLoggedIn();

    if (isAlreadyLoggedIn) {
      // User is already logged in, redirect to landing page
      return this.router.createUrlTree(['', 'landing']);
    }

    // User is not logged in, allow access to login/guest pages
    return true;
  }
}
